import React from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { states } from '@/constants/lifecycle';
import { fetchUserGroup } from '../actions/usergroups/read';
import { editUserGroupCancel } from '../actions/usergroups/update';

const CancelUserGroupAction = ({
  cancelUpdate,
  category,
  code,
  isDirty,
  isSaving,
  refresh,
  userGroup,
}) => {
  const intl = useIntl();
  const restoreUserGroup = (updates) => {
    if (updates) {
      refresh(category, code);
    } else {
      cancelUpdate(category, code);
    }
  };

  const handleOnClick = () => {
    const updates = !isEqual(userGroup.name, userGroup.copy.name)
      || !isEqual(userGroup.description, userGroup.copy.description);
    const cancel = !isDirty
      || !updates
      // eslint-disable-next-line no-alert
      || window.confirm(intl.formatMessage({ id: 'usergroup.edit.cancel.warning' }));

    if (cancel) {
      restoreUserGroup(updates);
    }
  };

  return (
    <RibbonMenu
      name="cancel"
      icon="cancel"
      message="actions.cancel"
      onClick={handleOnClick}
      className="aridhia-cancel-usergroup-action"
      disabled={isSaving}
    />
  );
};

const mapStateToProps = ({
  userGroups: { userGroups },
}, { category, code }) => {
  const userGroup = findResult(userGroups, category, code);

  return {
    userGroup,
    isDirty: userGroup?.isDirty,
    isSaving: userGroup?.saveStatus === states.PENDING,
  };
};

const mapDispatchToProps = {
  refresh: fetchUserGroup,
  cancelUpdate: editUserGroupCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelUserGroupAction);
